import { Action } from '@ngrx/store';
import { ICharityForms } from '../../../commons';

export enum CharityFormsActionTypes {
  LoadCharityFormsState = '[CharityForms] Load CharityForms State',
  LoadCharityFormsStateSuccess = '[CharityForms] Load CharityForms State Success',
  LoadCharityFormsStateFail = '[CharityForms] Load CharityForms State Fail',
  CharityFormsScreenErrorReset = '[CharityForms] CharityForms Screen Error Reset'

}

export class LoadCharityFormsState implements Action {
  readonly type = CharityFormsActionTypes.LoadCharityFormsState;
}

export class LoadCharityFormsStateSuccess implements Action {
  readonly type = CharityFormsActionTypes.LoadCharityFormsStateSuccess;
  constructor(public payload: ICharityForms ) {}
}

export class LoadCharityFormsStateFail implements Action {
  readonly type = CharityFormsActionTypes.LoadCharityFormsStateFail;
  constructor(public payload: any) {}
}

export class CharityFormsScreenErrorReset implements Action {
  readonly type = CharityFormsActionTypes.CharityFormsScreenErrorReset;
}

export type CharityFormsActions = 
  LoadCharityFormsState
  | LoadCharityFormsStateSuccess
  | LoadCharityFormsStateFail
  | CharityFormsScreenErrorReset;